<template>
  <div>
    <div id="app" class="fluid menu-left">
      <form id="logoutForm" class="navbar-right"></form>
      <!-- Top navbar -->
      <div id="menuSwipe" class="d-block d-sm-none" style="
          width: 100%;
          height: 62px;
          position: absolute;
          z-index: 10;
          background-color: grey;
          opacity: 0.2;
        "></div>
      <div id="asu_hdr" class="asu_hdr_gold">
        <div id="asu_logo" class="d-none d-sm-block">
          <a href="https://chs.asu.edu/" title="Arizona State University">
            <img src="../assets/asu_chs_logo.png" alt="Arizona State University" height="32" width="203"
              style="margin-top: 14px; border: 0" />
          </a>
        </div>
        <div id="asu_logo" class="d-block d-sm-none">
          <a href="https://chs.asu.edu/" title="Arizona State University">
            <img src="../assets/asu_chs_logo.png" alt="Arizona State University" height="32" style="
                margin-top: 14px;
                margin-left: auto;
                margin-right: auto;
                border: 0;
                width: 100%;
              " />
          </a>
        </div>
        <div id="asu_nav_wrapper d-none d-sm-block">
          <!-- Login partial -->

          <ul id="asu_login_module" class="d-none d-sm-block">
            <li id="sso_name">{{ user.userId }}</li>
            <li><a @click="logOff">Log off</a></li>
          </ul>

          <div id="asu_universal_nav" class="d-none d-sm-block">
            <ul>
              <li><a target="_top" href="https://www.asu.edu/">ASU Home</a></li>
              <li><a target="_top" href="https://my.asu.edu/">My ASU</a></li>
              <li>
                <a target="_top" href="https://www.asu.edu/colleges/">Colleges &amp; Schools</a>
              </li>
              <li>
                <a target="_top" href="https://www.asu.edu/map/">Map & Locations</a>
              </li>
              <li>
                <a target="_top" href="https://www.asu.edu/contactasu/" title="Directory, Index and other info">Contact
                  ASU</a>
              </li>
            </ul>
          </div>
          <!-- /#asu_universal_nav -->
        </div>
        <!-- /#asu_nav_wrapper -->
        <div id="asu_search_module" style="left: 0px; top: 6px" class="d-none d-sm-block">
          <fieldset class="asu_search_selection">
            <label for="asu_collection">
              <input type="radio" value="default_collection" id="asu_collection_radio" name="site" />ASU
            </label>
          </fieldset>

          <input name="Search" type="text" maxlength="200" id="asu_search_box" class="asu_search_box"
            onkeypress="checkEnterButton(event)" accesskey="S" onfocus="clearDefault(this);" value="Search ASU" />
          <input type="button" id="asu_search_button" class="asu_search_button" />
        </div>
      </div>
      <!-- Top navbar END -->
      <!-- Sidebar menu & content wrapper -->
      <div id="wrapper">
        <!-- Sidebar Menu -->
        <nav-menu params="route: route"></nav-menu>
        <!-- // Sidebar Menu END -->

        <div id="content">
          <b-alert :show="dev_env" variant="danger">THIS IS NOT A PRODUCTION ENVIRONMENT ( {{ env }} )</b-alert>

          <!-- <b-alert show variant="danger"><strong> {{ placementsMessage }} </strong></b-alert> -->

          <div v-if="messages && messages.globalMessage && messages.globalMessage.message"
            :class="[messages ? messages.globalMessage.type : '']" role="alert"
            v-html="messages ? messages.globalMessage.message : ''"></div>
          <div v-if="messages && messages.placementsMessage && messages.placementsMessage.message"
            :class="[messages ? messages.placementsMessage.type : '']" role="alert"
            v-html="messages ? messages.placementsMessage.message : ''">
          </div>
          <b-alert show variant="danger" class="impersonation-alert" v-if="user.isImpersonating">
            Viewing site as {{ user.userId }}
            <a href="/stopimpersonation" class="alert-link">[Stop Impersonation]</a>
          </b-alert>
          <div style="padding: 10px 10px 5px 10px">
            <div style="display: none" id="errorMessage" class="alert alert-error"></div>
            <router-view></router-view>
          </div>
        </div>

      </div>
    </div>
    <!-- Main container fluid END -->
    <!-- Footer -->
    <ul id="asu_footer" class="asu_dark_grey_footer">
      <!-- <li id="sparky">
                <img alt="Sparky" src="../assets/Sparky.png" style="height: 96px" />
            </li> -->
      <li class="d-none d-sm-inline">
        <a href="https://www.asu.edu/copyright/">Copyright &amp; Trademark</a>
      </li>
      <li class="d-none d-sm-inline">
        <a href="https://www.asu.edu/accessibility/">Accessibility</a>
      </li>
      <li class="d-none d-sm-inline">
        <a href="https://www.asu.edu/privacy/">Privacy</a>
      </li>
      <li class="d-none d-sm-inline">
        <a href="https://www.asu.edu/emergency/">Emergency</a>
      </li>
      <li class="no-border d-none d-sm-inline">
        <a href="https://www.asu.edu/contactasu/">Contact ASU</a>
      </li>
    </ul>
    <br />
    <br />
    <!-- // Footer END -->
    <spinner :show="showSpinner"></spinner>
  </div>
</template>

<script>
import Vue from "vue";
import NavMenu from "./nav-menu";
import MenuTree from "./menu/menu-tree";
import MenuItem from "./menu/menu-item";
import NavTree from "./menu/nav-tree";
import NavItem from "./menu/nav-item";
import homeApi from "../api/home";
import spinner from "./spinner";
import Widget from "../components/widget";

import messagesApi from "../api/messages.js";

import Datepicker from "vuejs-datepicker";
import { mapActions, mapState } from "vuex";

import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  fas, // eslint-disable-line no-unused-vars
  faCheck, // eslint-disable-line no-unused-vars
  faPlus, // eslint-disable-line no-unused-vars
  faTimes, // eslint-disable-line no-unused-vars
  faEdit, // eslint-disable-line no-unused-vars
  faBars, // eslint-disable-line no-unused-vars
  faUser, // eslint-disable-line no-unused-vars
  faUsers, // eslint-disable-line no-unused-vars
  faList, // eslint-disable-line no-unused-vars
  faLockOpen, // eslint-disable-line no-unused-vars
  faHome, // eslint-disable-line no-unused-vars
  faIdCard, // eslint-disable-line no-unused-vars
  faTable, // eslint-disable-line no-unused-vars
  faFileAlt, // eslint-disable-line no-unused-vars
  faCheckCircle, // eslint-disable-line no-unused-vars
  faTimesCircle // eslint-disable-line no-unused-vars
} from "@fortawesome/free-solid-svg-icons";

library.add(
  fas,
  faCheck,
  faPlus,
  faTimes,
  faEdit,
  faBars,
  faUser,
  faUsers,
  faList,
  faLockOpen,
  faHome,
  faIdCard,
  faTable,
  faFileAlt
);

Vue.component("nav-menu", NavMenu);
Vue.component("menu-tree", MenuTree);
Vue.component("menu-item", MenuItem);
Vue.component("nav-tree", NavTree);
Vue.component("nav-item", NavItem);
Vue.component("datepicker", Datepicker);
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);
Vue.component("spinner", spinner);
Vue.component("widget", Widget);
// babel-polyfill added for BootstrapVue to work with IE11
import "babel-polyfill";

import * as _ from "lodash"; // eslint-disable-line no-unused-vars

// for date formatting filters
Vue.use(require("vue-moment"));

import Vuelidate from "vuelidate";
Vue.use(Vuelidate);
require("vuelidate/lib/validators");

import DoughnutChart from "./charts/DoughnutChart.js";
Vue.component("doughnut-chart", DoughnutChart);

import BarChart from "./charts/BarChart.js";
//import placements from "../store/modules/placements.js";
Vue.component("bar-chart", BarChart);

export default {
  data() {
    return {
      //xsrf: document.getElementsByName('__RequestVerificationToken')[0].value //this.$cookie.get('XSRF-TOKEN')
      dev_env: process.env.NODE_ENV != "production",
      env: process.env.NODE_ENV,
      messages: {}
    };
  },

  computed: {
    ...mapState({
      user: state => state.auth.user,
      requestCount: state => state.spinner.count
    }),
    logOutUri: function() {
      return process.env.VUE_APP_BASE_URI + "/home/logoff";
    },
    showSpinner: function() {
      return this.requestCount > 0;
    }
  },

  methods: {
    ...mapActions(["getUser"]),

    logOff: function() {
      homeApi
        .logOff()
        .then(function(response) {
          var redirectUrl = response.data;
          window.location.replace(
            "https://weblogin.asu.edu/cas/logout?eventSource=castest"
          );
        })
        .catch(function(err) {
          console.log(err);
        });
    }
  },

  beforeCreate() {
    // try to get login user
    this.$store.dispatch("getUser");

    messagesApi.getMessages().then(response => {
      this.messages = response.data;
    });
  }
};
</script>

<style scoped>
#wrapper {
  position: relative;
  overflow: hidden;
  min-height: 85vh;
  width: 100%;
  float: left;
}

#content {
  margin-left: 235px;
}

.impersonation-alert {
  text-align: right;
  margin: 5px;
}

a {
  cursor: pointer;
}

@media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
  #content {
    margin-left: initial;
    margin-top: 30px;
  }

  #wrapper {
    min-height: 70vh;
  }
}
</style>
